import { Box, SectionHelper, Text } from '@wix/design-system';
import React from 'react';
export const PAGE_AUTO_DOM_ORDER_FIX_OPTION = {
  AUTO: 'auto',
  MANUAL: 'manual'
};

// Radio options for the page-level DOM order rule
export const getPageAutoDomaOrderRadioOptions = t => {
  return [{
    id: PAGE_AUTO_DOM_ORDER_FIX_OPTION.AUTO,
    label: t('accessibility-wizard.rules-list.page-auto-dom-order.radio.auto'),
    optionElement: /*#__PURE__*/React.createElement(SectionHelper, {
      showPrefixIcon: true,
      size: "small"
    }, /*#__PURE__*/React.createElement(Box, {
      padding: "0 4px"
    }, /*#__PURE__*/React.createElement(Text, {
      size: "tiny",
      weight: "thin",
      secondary: true
    }, t('accessibility-wizard.rules-list.page-auto-dom-order.radio.auto.note')))),
    value: PAGE_AUTO_DOM_ORDER_FIX_OPTION.AUTO
  }, {
    id: PAGE_AUTO_DOM_ORDER_FIX_OPTION.MANUAL,
    label: t('accessibility-wizard.rules-list.page-auto-dom-order.radio.manually'),
    optionElement: /*#__PURE__*/React.createElement(SectionHelper, {
      showPrefixIcon: true,
      size: "small"
    }, /*#__PURE__*/React.createElement(Box, {
      padding: "0 4px"
    }, /*#__PURE__*/React.createElement(Text, {
      size: "tiny",
      weight: "thin",
      secondary: true
    }, t('accessibility-wizard.rules-list.page-auto-dom-order.radio.manually.note')))),
    value: PAGE_AUTO_DOM_ORDER_FIX_OPTION.MANUAL
  }];
};
//# sourceMappingURL=radio-options.js.map